module.exports = "https://static.wmbcdn.com/uniweb/images/e8d97e7527a8de0eb39a7a7ad59fbd41.svg";